import React, { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export default function Navbar() {
  const { scrollY } = useScroll();
  const [scrolled, setScrolled] = useState(false);
  const [showCta, setShowCta] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return scrollY.on("change", (v) => {
      setScrolled(v > 20);
      setShowCta(v > (typeof window !== "undefined" ? window.innerHeight * 0.55 : 500));
    });
  }, [scrollY]);

  const links = [
    { href: "#comment", label: "Fonctionnement", testid: "nav-link-how" },
    { href: "#pourquoi", label: "Pourquoi", testid: "nav-link-why" },
    { href: "#apercu", label: "Aperçu", testid: "nav-link-glimpse" },
    { href: "#faq", label: "FAQ", testid: "nav-link-faq" },
  ];

  return (
    <>
      <motion.header
        data-testid="site-navbar"
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: [0.2, 0.7, 0.2, 1] }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-white/85 backdrop-blur-xl border-b border-[rgba(10,10,10,0.06)]"
            : "bg-transparent"
        }`}
      >
        <div className="mx-auto max-w-[1280px] px-5 md:px-8 h-28 md:h-40 flex items-center justify-between">
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center -ml-6 md:-ml-10"
            aria-label="MamaMatch"
          >
            <img
              src={ASSETS.logo}
              alt="MamaMatch"
              className="h-36 md:h-56 w-auto object-contain"
            />
          </a>

          <nav className="hidden md:flex items-center gap-8 text-[14px] font-medium text-[#0A0A0A]/80">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                className="mm-underline"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#download"
              data-testid="nav-cta"
              aria-hidden={!showCta}
              tabIndex={showCta ? 0 : -1}
              className={`btn-primary text-[13px] md:text-[14px] font-medium px-4 py-2.5 md:px-5 md:py-3 inline-flex items-center transition-all duration-300 ${
                showCta
                  ? "opacity-100 translate-y-0 pointer-events-auto"
                  : "opacity-0 -translate-y-1 pointer-events-none"
              }`}
            >
              Télécharger
            </a>
            <button
              type="button"
              data-testid="nav-mobile-toggle"
              aria-label="Menu"
              onClick={() => setOpen(true)}
              className="md:hidden w-11 h-11 flex items-center justify-center rounded-full border border-[rgba(10,10,10,0.08)]"
            >
              <Menu className="w-5 h-5" />
            </button>
          </div>
        </div>
      </motion.header>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="fixed inset-0 z-[60] bg-white flex flex-col"
        >
          <div className="h-28 px-5 flex items-center justify-between border-b border-[rgba(10,10,10,0.06)]">
            <img
              src={ASSETS.logo}
              alt="MamaMatch"
              className="h-36 w-auto object-contain -ml-6"
            />
            <button
              type="button"
              data-testid="nav-mobile-close"
              aria-label="Fermer"
              onClick={() => setOpen(false)}
              className="w-11 h-11 flex items-center justify-center rounded-full border border-[rgba(10,10,10,0.08)]"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <nav className="flex-1 px-5 py-8 flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-4 text-2xl font-semibold text-[#0A0A0A] border-b border-[rgba(10,10,10,0.06)]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#download"
              onClick={() => setOpen(false)}
              className="btn-primary mt-6 text-center py-4 text-[15px] font-medium"
            >
              Télécharger MamaMatch
            </a>
          </nav>
        </div>
      )}
    </>
  );
}
